import React from 'react'

import {DateStep} from '../../../../shared/order-editor/components/fields/Date'

/**
 * OrderIntake-specific wrapper for DateStep.
 * Uses default configuration without any custom parameters.
 * This component is used in the order intake flow where all fields
 * are freely editable without approval requirements.
 */
export const OrderIntakeDateStep: React.FC = () => {
  return <DateStep />
}
